import { commonHelpers } from 'helpers/commonHelper';
import { dateHelper } from 'helpers/dateHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục thu nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function DuThuCongDoanTable({ academicYear, danhmucthucongdoans, duthucongdoans, data, setData }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const numOfMonthForYear = get(academicYear, 'congDoanNumOfMonth', 12);
    const congDoanStartMonth = get(academicYear, 'congDoanStartMonth', 5);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (danhmucthucongdoans) {
            danhmucthucongdoans.forEach((dm) => {
                const matchedDuThuCongDoan = duthucongdoans ? duthucongdoans.find((duthu) => dm.code === duthu.danhMucThuCongDoanCode) : {};
                const row = {
                    dmId: dm.id,
                    code: dm.code,
                    name: dm.name,
                    id: get(matchedDuThuCongDoan, 'id'),
                    danhMucChiCongDoanCode: get(matchedDuThuCongDoan, 'danhMucThuCongDoanCode'),
                    junAmount: get(matchedDuThuCongDoan, 'junAmount', '') ? get(matchedDuThuCongDoan, 'junAmount') : '',
                    julAmount: get(matchedDuThuCongDoan, 'julAmount', '') ? get(matchedDuThuCongDoan, 'julAmount') : '',
                    augAmount: get(matchedDuThuCongDoan, 'augAmount', '') ? get(matchedDuThuCongDoan, 'augAmount') : '',
                    sepAmount: get(matchedDuThuCongDoan, 'sepAmount', '') ? get(matchedDuThuCongDoan, 'sepAmount') : '',
                    octAmount: get(matchedDuThuCongDoan, 'octAmount', '') ? get(matchedDuThuCongDoan, 'octAmount') : '',
                    novAmount: get(matchedDuThuCongDoan, 'novAmount', '') ? get(matchedDuThuCongDoan, 'novAmount') : '',
                    decAmount: get(matchedDuThuCongDoan, 'decAmount', '') ? get(matchedDuThuCongDoan, 'decAmount') : '',
                    janAmount: get(matchedDuThuCongDoan, 'janAmount', '') ? get(matchedDuThuCongDoan, 'janAmount') : '',
                    febAmount: get(matchedDuThuCongDoan, 'febAmount', '') ? get(matchedDuThuCongDoan, 'febAmount') : '',
                    marAmount: get(matchedDuThuCongDoan, 'marAmount', '') ? get(matchedDuThuCongDoan, 'marAmount') : '',
                    aprAmount: get(matchedDuThuCongDoan, 'aprAmount', '') ? get(matchedDuThuCongDoan, 'aprAmount') : '',
                    mayAmount: get(matchedDuThuCongDoan, 'mayAmount', '') ? get(matchedDuThuCongDoan, 'mayAmount') : '',
                    extraAmount1: get(matchedDuThuCongDoan, 'extraAmount1', '') ? get(matchedDuThuCongDoan, 'extraAmount1', '') : '',
                    extraAmount2: get(matchedDuThuCongDoan, 'extraAmount2', '') ? get(matchedDuThuCongDoan, 'extraAmount2', '') : '',
                    duchi: matchedDuThuCongDoan,
                };
                rows.push(row);
            });
            setRows(rows);
        }
    }, [duthucongdoans, danhmucthucongdoans]);

    const buildDynamicColumnBaseOnYear = useCallback(() => {
        const isEnableDuThu = commonHelpers.ableToPersitDuThuChi(academicYear?.name);
        const fieldMap = dateHelper.duThuFieldMappedByMonth();
        const extraKeys = ['extraAmount1', 'extraAmount2'];

        const columns = [];
        for (let i = 0; i < numOfMonthForYear; i++) {
            const position = i + 1;
            const month = ((congDoanStartMonth - 1 + i) % 12) + 1;
            const key = position <= 12 ? fieldMap.get(month) : extraKeys[position - 13];
            columns.push({ key, name: `Tháng ${month}`, editable: isEnableDuThu, width: 80 });
        }
        return columns;
    }, [numOfMonthForYear, congDoanStartMonth]);

    useEffect(() => {
        const commonColumns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
        ];
        const dynamicColumns = buildDynamicColumnBaseOnYear();
        const columns = [...commonColumns, ...dynamicColumns].map((item) => {
            return { ...item, ...{ resizable: true } };
        });
        setColumns(columns);
    }, [buildDynamicColumnBaseOnYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newRows);
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default DuThuCongDoanTable;
